export enum TasksColumnSizesSmall {
  Checkbox = 4,
  Description = 56,
  TeamMembers = 20,
  DueDate = 20,
}
